import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@/src/store'
import { VisaState } from './type'

const initialState: VisaState = {
    data: {
        nationality: { value: '', index: -1 },
        destination: { value: '', index: -1 }
    }
}

const travelDetailsSlice = createSlice({
    name: 'travelDetails',
    initialState,
    reducers: {
        setTravelDetails: (state, action) => {
            state.data = {
                ...state.data,
                ...action.payload
            }
        }
    }
})

export const { setTravelDetails } = travelDetailsSlice.actions
export const getTravelDetails = (state: RootState) => state.travelDetails.data

export default travelDetailsSlice.reducer
